import { appStakeUnstakePopupState } from "@/atoms/appPopupState"
import { restakingBalancesAtom } from "@/atoms/restakingState"
import { refreshCounterRestakingAtom } from "@/atoms/settings"
import { ButtonConnect } from "@/components/buttonConnect"
import useRestaking from "@/hooks/useRestaking"
import useTrans from "@/hooks/useTrans"
import { STAKING, UNSTAKING } from "@/utils/constants"
import { Box, Stack, Typography } from "@mui/material"
import "dayjs/locale/vi"
import { useAtom, useAtomValue, useSetAtom } from "jotai"
import { useEffect, useRef } from "react"
import Stake from "./stake"
import Unstake from "./unstake"

const View = () => {
  const trans = useTrans()
  const { address, fetchAvailableREL, fetchAvailableReward } = useRestaking()

  // atoms
  const setStakeUnstakePopupState = useSetAtom(appStakeUnstakePopupState)
  const [, setRestakingBalances] = useAtom(restakingBalancesAtom)
  const refreshStakingCounter = useAtomValue(refreshCounterRestakingAtom)

  const walletConnectButtonRef = useRef<HTMLButtonElement | null>(null)

  const handleConnectWalletClick = () => {
    if (walletConnectButtonRef.current) {
      const demonWalletConnectButton = walletConnectButtonRef.current.querySelector("button")
      if (demonWalletConnectButton) {
        demonWalletConnectButton.click()
      }
    }
  }

  const handleOpenStakingModal = (type: typeof STAKING | typeof UNSTAKING) => {
    if (address) {
      setStakeUnstakePopupState({
        isOpen: true,
        type,
      })
    } else {
      handleConnectWalletClick()
    }
  }

  // Fetch available balances
  useEffect(() => {
    const fetchOwnBalances = async () => {
      if (address) {
        const [availableRELResult, availableRewardResult] = await Promise.all([
          fetchAvailableREL(),
          fetchAvailableReward(),
        ])
        let availableREL = 0
        let availableReward = 0
        if (availableRELResult.isSucceeded) {
          availableREL = availableRELResult.result
        }
        if (availableRewardResult.isSucceeded) {
          availableReward = availableRewardResult.result
        }
        setRestakingBalances({
          stakeToken: availableREL,
          rewardToken: availableReward,
        })
      } else {
        setRestakingBalances({
          stakeToken: 0,
          rewardToken: 0,
        })
      }
    }

    fetchOwnBalances()
  }, [fetchAvailableREL, fetchAvailableReward, setRestakingBalances, address, refreshStakingCounter])

  return (
    <>
      <Stack
        className='p-4 sm:px-10 sm:py-6 border border-solid border-secondary rounded-lg bg-white h-full'
        gap={0}
        data-testid='staking-detail-my-assets'
      >
        <Typography className='font-semibold text-xl sm:text-2xl'>{trans.staking.detail.my_assets}</Typography>

        <Stake handleOpenStakingModal={handleOpenStakingModal} />

        <hr className='my-10 text-secondary' />

        <Unstake handleOpenStakingModal={handleOpenStakingModal} />
      </Stack>

      <Box display='none' ref={walletConnectButtonRef}>
        <ButtonConnect />
      </Box>
    </>
  )
}

export default View
